import { createElement } from 'react';

var component = function component(props) {
  return createElement("svg", Object.assign({
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props), createElement("path", {
    d: 'M13.125 3h2.228c.161.804.608 1.82 1.389 2.826.765.986 1.78 1.674 3.133 1.674v2.25c-1.973 0-3.455-.915-4.5-2.057v7.682A5.625 5.625 0 1 1 9.75 9.75V12a3.375 3.375 0 1 0 3.375 3.375V3Z'
  }));
};

export { component };
//# sourceMappingURL=ItTiktok-24f49198.js.map
